import { Code, Grid } from '@chakra-ui/react';
import React from 'react'

const PoolRankingDetails = ({timeStamp}) => {
    const job_profiles = timeStamp?.jds.map(jp=> jp.PK).join(', ')
    return (
        <Grid templateColumns="repeat(1, 1fr)" mb={10}>
          <Code colorScheme="" children={"run id: " + timeStamp?.run_id} />
          <Code colorScheme="" children={"career stage: " + timeStamp?.career_stage} />
           <Code colorScheme="" children={"pool name: " + timeStamp?.pool_name} />
          <Code colorScheme="" children={"job profile: " + job_profiles} /> 
          <Code colorScheme="" children={"pool created by: " + timeStamp?.author_email} />
        </Grid>
      );
    };

export default PoolRankingDetails